/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Component, Input, ElementRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {InputAccessor} from '../input-accessor';

@Component({
    selector: 'ui-radio',
    template: require('./ui-radio.html'),
    styles: [require('./ui-radio.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: UiRadio, multi: true}
    ],
})



export class UiRadio extends InputAccessor {

    @Input() value: string;
    @Input() altValue: string;

    constructor(public elementRef: ElementRef) {
        super();
    }

    public prepareValueHook() {}

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-radio/ui-radio.ts